import { inject } from '@angular/core'
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router'
import { CompetitionService } from '../shared/services/competition.service'

export const competitionResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot) => {
  const cs = inject(CompetitionService)
  cs.competitionId.set(route.paramMap.get('competitionId') ?? '')
  // Seed only; never clobber a season the user has already picked. The season
  // is shared app-wide and persisted, so it survives navigation and reloads.
  cs.seedSeason()
  // Once the competition's seasons are known, one with nothing in this season opens on its newest.
  cs.requestLanding()
  return true
}
